import { createSelector } from 'reselect';

export const homeSelector = (state) => state.homeReducer;

export const selectOrderSetup = createSelector(
  [homeSelector],
  (home) => home.orderSetup
);

export const selectIsEnabledGoogleReview = createSelector(
  selectOrderSetup,
  (orderSetup) => orderSetup?.isEnableGoogleReview || false
);

// { [menuItemId]: [{ voucher, roles: ['buy' | 'get'] }] } for item-level offer badges.
// offerVouchers is already empty when no voucher is displayed on the homepage.
export const selectVouchersByMenuItemId = createSelector(
  [(state) => state.homeReducer.offerVouchers],
  (vouchers = []) => {
    const map = {};
    vouchers.forEach((voucher) => {
      const { buyConfig, getConfig } = voucher;
      if (buyConfig?.anyItem || getConfig?.anyItem) return;

      const add = (items, role) =>
        (items ?? []).forEach(({ _id }) => {
          if (!_id) return;
          if (!map[_id]) map[_id] = [];
          const list = map[_id];
          const entry = list.find((e) => e.voucher === voucher);
          if (entry) {
            if (!entry.roles.includes(role)) entry.roles.push(role);
          } else {
            list.push({ voucher, roles: [role] });
          }
        });

      add(buyConfig?.menuItems, 'buy');
      add(getConfig?.menuItems, 'get');
    });
    return map;
  }
);
